var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 180.3 182.35" }, props),
    React.createElement(
      "title",
      null,
      "panels-right"
    ),
    React.createElement("path", { fill: "none", stroke: "#969696", strokeLinecap: "round", strokeLinejoin: "round", d: "M98.55 7.95h64.7v173.9h-64.7z" }),
    React.createElement("path", { d: "M1.55 6.55c0-1.8.6-1.8.6-1.8h172.3v1.8s0 1.8-19 1.8H2.15s-.6 0-.6-1.8" }),
    React.createElement("path", { d: "M1.55 6.55c0-1.8.6-1.8.6-1.8h172.3v1.8s0 1.8-19 1.8H2.15s-.6 0-.6-1.8z", fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.7" }),
    React.createElement("path", { d: "M11.85 6.35a5.5 5.5 0 0 1-11 0 5.55 5.55 0 0 1 5.5-5.5 5.42 5.42 0 0 1 5.5 5.5" }),
    React.createElement("path", { d: "M11.85 6.35a5.5 5.5 0 0 1-11 0 5.55 5.55 0 0 1 5.5-5.5 5.42 5.42 0 0 1 5.5 5.5z", fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.7" }),
    React.createElement("path", { d: "M179.45 6.35a5.5 5.5 0 1 1-5.5-5.5 5.36 5.36 0 0 1 5.5 5.5" }),
    React.createElement("path", { d: "M179.45 6.35a5.5 5.5 0 1 1-5.5-5.5 5.42 5.42 0 0 1 5.5 5.5z", fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.7" })
  );
});